<template>
    <div class="background">
        <div class="inputForm">
            <van-row>
                <van-col span="12">
                    <a href="https://u.jd.com/n0b8gZ">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ntw5jYy.jpg" width="90%"/>
                    </a>
                </van-col>
                <van-col span="12">
                    <a href="https://u.jd.com/jWxt6e">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ntw5hTW.jpg" width="90%"/>
                    </a>
                </van-col>
            </van-row>

            <van-row>
                <van-col span="12">
                    <a href="https://u.jd.com/uV4HA3">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ntw5fpo.jpg" width="90%"/>
                    </a>
                </van-col>
                <van-col span="12">
                    <a href="http://item.jd.com/10020866143365.html">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ntw5eI5.jpg" width="90%"/>
                    </a>
                </van-col>
            </van-row>

            <!--<a href="https://item.jd.com/69913808653.html">-->
                <!--<img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Nwm0SQh.png" width="90%"/>-->
            <!--</a>-->

            <van-row v-if="jobInfo" style="margin: 1rem 0;">
                <van-col span="12">
                    <van-button type="danger" size="large" :url="jobInfo.linkAtrr1" style="width:90%;">
                        <div style="font-size: 1.6rem;">
                            领6元金贴
                        </div>
                    </van-button>
                </van-col>
                <van-col span="12">
                    <van-button type="danger" size="large" :url="jobInfo.jobLink" style="width:90%;">
                        <div style="font-size: 1.6rem;">
                            领取1元购权益
                        </div>
                    </van-button>
                </van-col>
            </van-row>

            <div style="font-size: 1rem; margin-top: 1rem;">
                温馨提示<br/>
                白条新用户享受特价<br/>
                非白条新用户无法享受此优惠
            </div>

            <div v-if="jobInfo" style="margin-top: 1rem; text-align:center;">
                <van-row>
                    <van-col span="12">
                        <van-button plain hairline type="danger" size="small"
                                    url="https://www9.53kf.com/m.php?kf_sign=jk4NjMTU5MU0MzExNzc5NTk0NDkxMDEyNzIyMjQyODA%253D&arg=10224280&style=1&cid=72224280">
                            联系客服
                        </van-button>
                    </van-col>
                    <van-col span="12">
                        <van-button plain hairline type="danger" size="small" @click="dialogVisible=true">
                            分享海报
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </div>

        <van-dialog v-model="dialogVisible" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <img :src="shareImgSrc" width="100%"/>
            <vue-canvas-poster :widthPixels="640" :painting="painting" @success="success" @fail="fail">
            </vue-canvas-poster>
        </van-dialog>

        <van-dialog v-model="qrcodeVisible" title="京东金融扫码领购物红包" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <div v-if="jobInfo" style="margin-top: 2rem;">
                <vue-qr :margin="0" :text="jobInfo.jobQrCode" :logoScale="0.25"
                        v-if="jobInfo.jobQrCode" :size="185" :callback="qrCallback"></vue-qr>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';
    import {VueCanvasPoster} from 'vue-canvas-poster';
    import vueQr from 'vue-qr';

    export default {
        components: {
            VueCanvasPoster,
            vueQr,
        },
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                jobInfo: null,
                dialogVisible: false,
                qrcodeVisible: false,
                shareImgSrc: '',
                painting: {
                    width: '640px',
                    height: '1008px',
                    background: '#f4f5f7',
                    views: [
                        {
                            type: 'image',
                            url: require('../../../assets/posters/baitiao_water.png'),
                            css: {
                                // top: '20px',
                                // left: '36px',
                                // width: '80px',
                                // height: '80px'
                            }
                        },
                        {
                            type: 'rect',
                            css: {
                                top: '630px',
                                left: '430px',
                                color: '#fff',
                                width: '166px',
                                height: '166px'
                            }
                        },
                        {
                            type: 'qrcode',
                            content: window.location.href,
                            css: {
                                top: '633px',
                                left: '433px',
                                color: '#000',
                                width: '160px',
                                height: '160px'
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
            qrCallback(url, id) {
            },
        },
        created() {
            document.title = "京东白条购物";
            if (!this.query.traderId) {
                return;
            }

            mainAPI.getInfoByTraderId(68, this.query.traderId).then((result) => {
                this.jobInfo = result.data;
            }).catch(() => {
            })
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O05KE2O.png",
                "title": "京东白条购物",
                "desc": "6元金贴 + 1元购权益",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("baiTiaoShopping/water", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NwmnEIN.png');
        background-size: 100% 100%;
        height: 75rem;
        padding-top: 16rem;
        text-align: center;
    }

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 1rem;
    }

</style>
